module.exports = __webpack_public_path__ + "img/COMBO RAINBOW LIME.b12f0da.svg";